import { createContext, useContext } from 'react';
function printError() {
    console.error(`
You are using WalletContext without provide the WalletContext.Provider.
Please wrap your sub-components with a WalletProvider and provide required values.
`);
}
const DEFAULT_CONTEXT = {
    autoConnect: false,
    connecting: false,
    connected: false,
    disconnecting: false,
    /* eslint-disable */
    select(_name) {
        printError();
    },
    connect() {
        printError();
        return Promise.reject();
    },
    disconnect() {
        printError();
        return Promise.reject();
    },
    signTransaction(_transaction) {
        printError();
        return Promise.reject();
    },
    signMessage(_message) {
        printError();
        return Promise.reject();
    },
    /* eslint-enable */
};
Object.defineProperty(DEFAULT_CONTEXT, 'wallets', {
    get() {
        printError();
        return [];
    },
});
Object.defineProperty(DEFAULT_CONTEXT, 'wallet', {
    get() {
        printError();
        return null;
    },
});
Object.defineProperty(DEFAULT_CONTEXT, 'address', {
    get() {
        printError();
        return null;
    },
});
export const WalletContext = createContext(DEFAULT_CONTEXT);
export function useWallet() {
    return useContext(WalletContext);
}
//# sourceMappingURL=useWallet.js.map